module.exports = __webpack_public_path__ + "img/03.5a9207c8.png";